export default __webpack_public_path__ + "static/media/Img_072.234fbce7.jpg";